var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('PublicPageFrame', {
    attrs: {
      "backgroundPath": "/img/themeBackgrounds/background-purple.jpg"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var columnWidth = _ref.columnWidth;
        return [_c('div', {
          attrs: {
            "id": "topFlexer"
          }
        }), _vm.referralInfo ? _c('div', {
          attrs: {
            "id": "referrerFrame"
          }
        }, [_c('ik-image', {
          attrs: {
            "path": _vm.imageSrc,
            "transformation": [{
              width: columnWidth / 3,
              height: columnWidth / 3
            }],
            "alt": "User profile photo",
            "id": "profilePhoto"
          }
        }), _c('h2', [_vm._v("Congrats! " + _vm._s((_vm.referralInfo.referrerUser || {}).fullName || 'A Reach creator')), _c('br'), _vm._v("has vouched for you.")]), _c('PillButton', {
          attrs: {
            "id": "continueButton",
            "large": ""
          },
          on: {
            "click": _vm.proceedToAuth
          }
        }, [_vm._v("Continue")]), _c('PillButton', {
          attrs: {
            "id": "resetButton",
            "transparentOnDark": ""
          },
          on: {
            "click": _vm.resetReferral
          }
        }, [_vm._v("Use a different invite code")])], 1) : _c('div', {
          staticClass: "genericBackdropGradient",
          attrs: {
            "id": "codeInputFrame"
          }
        }, [_c('h3', [_vm._v("Enter your invite code:")]), _c('CodeInput', {
          attrs: {
            "charCount": _vm.CODE_LENGTH,
            "disabled": _vm.referralCode.length === _vm.CODE_LENGTH && !_vm.referralCodeError,
            "error": Boolean(_vm.referralCode.length === _vm.CODE_LENGTH && _vm.referralCodeError),
            "valueFilterFunction": function valueFilterFunction(value) {
              return value.toUpperCase();
            }
          },
          model: {
            value: _vm.referralCode,
            callback: function callback($$v) {
              _vm.referralCode = $$v;
            },
            expression: "referralCode"
          }
        }), _vm.referralCode.length === _vm.CODE_LENGTH ? _c('div', [_vm.referralCodeError ? _c('h4', {
          attrs: {
            "id": "codeError"
          }
        }, [_vm._v(_vm._s(_vm.referralCodeError))]) : _c('LoadingSpinner', {
          attrs: {
            "id": "infoLoading",
            "defaultDimensions": false
          }
        })], 1) : _c('router-link', {
          attrs: {
            "to": {
              name: 'auth'
            }
          }
        }, [_c('PillButton', {
          attrs: {
            "id": "signInButton",
            "transparentOnDark": ""
          }
        }, [_vm._v("I already have an account")])], 1)], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }